import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../../http";
import Spinner from "../../Spinner";
import { capitalize } from "@mui/material";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import HeaderWrapper from "../../Header/HeaderWrapper";
import FooterWrapper from "../../Footer/FooterWrapper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";

// ✅ Convert HTML safely into plain text
const htmlToText = (html = "") => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
  } catch {
    return (html || "").replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
  }
};

// ✅ Make excerpt with ellipsis only if longer
const makeExcerpt = (html = "", limit = 130) => {
  const text = htmlToText(html);
  if (text.length <= limit) {
    return { excerpt: text, isLong: false };
  }
  const cut = text.slice(0, limit).trimEnd();
  return { excerpt: `${cut}…`, isLong: true };
};

function QuoteSliderReviewPage() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [reviewsData, setReviewsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    getReviewsData();
  }, []);

  const getReviewsData = async () => {
    try {
      setIsLoading(true);
      const response = await SendPostRequest("reviews");
      if (Array.isArray(response?.data) && response?.data.length > 0) {
        setReviewsData(response.data);
      } else {
        setReviewsData([]);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviewsData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowMore = (review) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReview(null);
  };

  return (
    <div className="page-wrapper-inner">
      <HeaderWrapper />
      <TextMainBannerWrapper Heading="Reviews" Image="theme-2-banner-review.webp"/>

      <div className="container">
        <h2 className="my-5 text-center">
          {isLoading
            ? ""
            : reviewsData?.length === 0
            ? "No Record Available"
            : "WHAT PATIENTS ARE SAYING"}
        </h2>

        <div className="row testimonails" data-animation="fadeInRight">
          {isLoading ? (
            <div className="d-flex align-items-center justify-content-center w-100">
              <Spinner />
            </div>
          ) : reviewsData?.length === 0 ? (
            <div className="d-flex align-items-center justify-content-center w-100"></div>
          ) : (
            reviewsData.map((data, index) => {
              const { excerpt, isLong } = makeExcerpt(data?.detail, 110);

              return (
                <div
                  key={index}
                  className="col-lg-4 testimonial-style-5 dark-switch item mb-4"
                >
                  <div className="testimonial-style-2 mb-3" style={{ minHeight: "290px" }}>
                    <div className="testimonial-inner">
                      <div className="testimonial-details text-left">
                        <div
                          className="testimonial-description margin-top-15"
                          style={{
                            minHeight: "140px",
                            display: "flex",
                            alignItems: "flex-start",
                          }}
                        >
                          <p className="mb-4 pb-1">
                            {excerpt}
                            {isLong && (
                              <>
                                {" "}
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleShowMore(data);
                                  }}
                                  className="fw-bold"
                                  style={{ color: "#fff" }}
                                >
                                  See More
                                </Link>
                              </>
                            )}
                          </p>
                        </div>

                        <div className="client-details text-left left-align d-flex align-items-center">
                          <div className="client-image">
                            <img
                              className="img-circle"
                              src={
                                data?.profile_image ||
                                "/assets/img/no-image.png"
                              }
                              style={{ width: "65px", height: "65px" }}
                              width="65"
                              height="65"
                              alt={data?.full_name}
                            />
                          </div>
                          <div className="client-info ms-3">
                            <h4 className="mb-1">{data?.full_name}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* ✅ Modal with full HTML detail */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedReview && (
            <div
              dangerouslySetInnerHTML={{
                __html: selectedReview?.detail || "",
              }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-default" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <FooterWrapper />
    </div>
  );
}

export default QuoteSliderReviewPage;
